class CookieModules {

  constructor(basePath, apiClient) {

    this.apiClient = apiClient;
    this.basePath = `${basePath}/cookie-modules`;

  }

  async getCookieModules() {

    const path = this.basePath;

    return this.apiClient.get(path, {}, {});

  }

  async createCookieModule(cookieModule) {

    const path = this.basePath;

    return this.apiClient.post(path, {}, {}, cookieModule);

  }

  async getCookieModuleById(cookieModuleId) {

    const path = `${this.basePath}/:cookieModuleId`;

    return this.apiClient.get(path, { cookieModuleId }, {});

  }

  async updateCookieModuleById(cookieModuleId, cookieModule) {

    const path = `${this.basePath}/:cookieModuleId`;

    return this.apiClient.put(path, { cookieModuleId }, {}, cookieModule);

  }

  async deleteCookieModuleById(cookieModuleId) {

    const path = `${this.basePath}/:cookieModuleId`;

    return this.apiClient.delete(path, { cookieModuleId }, {});

  }

}

export default CookieModules;